module.exports = __webpack_public_path__ + "static/media/ufo.cb4c4651.svg";